import { Badge, Button, notification, Popover } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/store';
import { vacationsScheduleSupervisorApi } from 'app/services/edpApiV1/supervisor/vacationsSchedule';
import { getCurrentDivision } from 'entities/divisions/model';
import { TabKeys } from 'features/divisions';
import {
  getMultiSelectedSubtitutionVacations,
  setVacations,
} from 'entities/vacationsSchedule/model/multiSelectSubtitution';
import { blue } from 'features/vacationsSchedule';
import { getVacationCheduleSupervisor } from 'entities/supervisor/vacationSchedule';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import { VacationsScheduleSubordinatesPull } from './vacationPull';
import style from './index.module.scss';
import ChekboxPick from './checboxPick/ChekboxPick';

export const VacationsScheduleSubordinates = () => {
  const { currentOption } = useAppSelector(getCurrentDivision);
  const [sendHRVacationsScheduleDeputy, { isLoading: isDeputySendHRLoading }] =
    vacationsScheduleSupervisorApi.useVacationScheduleSendToHrDeputyMutation();
  const [sendHRVacationsScheduleActing, { isLoading: isActingSendHRLoading }] =
    vacationsScheduleSupervisorApi.useVacationScheduleSendToHrActingMutation();
  const [sendHRVacationsScheduleSupervisor, { isLoading: isSupervisorSendHRLoading }] =
    vacationsScheduleSupervisorApi.useVacationScheduleSendToHrSupervisorMutation();

  const [approveVacationsScheduleDeputy, { isLoading: isDeputyApproveLoading }] =
    vacationsScheduleSupervisorApi.useVacationScheduleApproveDeputyMutation();
  const [approveVacationsScheduleActing, { isLoading: isActingApproveLoading }] =
    vacationsScheduleSupervisorApi.useVacationScheduleApproveActingMutation();
  const [approveVacationsScheduleSupervisor, { isLoading: isSupervisorApproveLoading }] =
    vacationsScheduleSupervisorApi.useVacationScheduleApproveSupervisorMutation();

  const multiVacations = useAppSelector(getMultiSelectedSubtitutionVacations);
  const dispatch = useAppDispatch();
  const { data } = useAppSelector(getVacationCheduleSupervisor);

  const sendToHR = async () => {
    if (!currentOption) {
      return;
    }
    try {
      switch (currentOption.type) {
        case TabKeys.ACTING:
          await sendHRVacationsScheduleActing({
            divisionId: currentOption.value,
          }).unwrap();
          break;
        case TabKeys.DEPUTY:
          await sendHRVacationsScheduleDeputy({
            divisionId: currentOption.value,
          }).unwrap();
          break;
        case TabKeys.SUPERVISOR:
          await sendHRVacationsScheduleSupervisor().unwrap();
          break;
      }
      notification.success({ message: 'Отправлено HR' });
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    }
  };

  const clearAllData = () => {
    dispatch(setVacations([]));
  };

  const approve = async () => {
    if (!currentOption) {
      return;
    }
    try {
      switch (currentOption.type) {
        case TabKeys.ACTING:
          await approveVacationsScheduleActing({
            divisionId: currentOption.value,
            employeeIds: multiVacations.data,
          }).unwrap();
          break;
        case TabKeys.DEPUTY:
          await approveVacationsScheduleDeputy({
            divisionId: currentOption.value,
            employeeIds: multiVacations.data,
          }).unwrap();
          break;
        case TabKeys.SUPERVISOR:
          await approveVacationsScheduleSupervisor({ employeeIds: multiVacations.data }).unwrap();
          break;
      }
      notification.success({ message: 'Запланированный отпуск согласован' });
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    }
  };

  return (
    <>
      <div className={style.vacations__panel}>
        <h3>Планирование отпусков сотрудников</h3>
        <div className={style.buttons}>
          <Button
            type="primary"
            onClick={sendToHR}
            loading={isDeputySendHRLoading || isActingSendHRLoading || isSupervisorSendHRLoading}
          >
            Отправить HR
          </Button>

          <Popover
            content={<ChekboxPick clearAllData={clearAllData} approve={approve} multivacations={multiVacations.data} />}
            title="Выберите действие"
            trigger="click"
          >
            <Button loading={isDeputyApproveLoading || isActingApproveLoading || isSupervisorApproveLoading}>
              Согласовать группу
              {multiVacations.data.length !== 0 && <Badge count={multiVacations.data.length} color={blue} showZero />}
            </Button>
          </Popover>
        </div>
      </div>

      <div className={style.wrap}>
        <VacationsScheduleSubordinatesPull />
      </div>
    </>
  );
};
